(async () => {

  if (!customElements.get('featured-blog-posts-swiper')) {

    const Swiper = (await import('swiper')).default;
    const { Autoplay, Navigation, Pagination, Scrollbar } = await import('swiper/modules');

    // Modules are now included in the Swiper constructor options

    class featuredBlog extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-featured-blog-posts-swiper]');

        this.swiperOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          loop: false,
          autoplay: false,
          slidesPerView: 3,
          direction: 'horizontal',
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.init();

      }

      init() {

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });

        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.featuredBlog = featuredBlog;
    customElements.define('featured-blog-posts-swiper', featuredBlog);
  }

})();
